import Vue, { VueConstructor } from "vue";
import BannerPWA from "@/views/PageMore/components/BannerPWA";
import MoreMenuItemDefault from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemDefault";
import MoreMenuItemNSFWUserSetting from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemNSFWUserSetting";
import MoreMenuItemSeparator from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemSeparator";
import MoreMenuProfileInfo from "@/views/PageMore/components/MoreMenuProfileInfo";
import { IMoreMenuItem, MENU_MODULES } from "@/views/PageMore/config";

export function getMoreMenuItem(item: IMoreMenuItem): VueConstructor<Vue> {
  switch (item.name) {
    case MENU_MODULES.PWA_BANNER:
      return BannerPWA;
    case MENU_MODULES.PROFILE_INFO:
      return MoreMenuProfileInfo;
    case MENU_MODULES.NSFW_USER_SETTINGS:
      return MoreMenuItemNSFWUserSetting;
    case MENU_MODULES.SEPARATOR:
      return MoreMenuItemSeparator;
    default:
      return MoreMenuItemDefault;
  }
}
